import { BusinessPartnerGateway } from '../domain/business-partner.gateway';
import { BusinessPartnerParams } from '../domain/business-partner.entities';

export class GetBusinessPartnerUseCase {
    constructor(private gate: BusinessPartnerGateway) { }

    async execute(params: BusinessPartnerParams): Promise<boolean> {
        return await this.gate.getBusinessPartner(params);
    }
}

